import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d126101"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "MCalendario p-input-filled p-float-label field",
  "data-testid": "MCalendario"
}
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  style: {"color":"red"}
}

import Calendar from "primevue/calendar"
  import { computed, withDefaults, Ref } from "vue"
  import {
    CalendarValueType,
    CalendarHourFormatType,
  } from "./MCalendario.interface"

  interface Props {
    rotulo?: string
    formatoData?: string
    formatoHora?: CalendarHourFormatType
    somenteHora?: boolean
    modelValue: CalendarValueType | Ref<CalendarValueType>
    obrigatorio?: boolean
    mostrarHoras?: boolean
    destino?: string
    mensagemDeErro?: string | Ref<string>
    icon?: string
    maxData?: Date
    minData?: Date
    esconderPicker?: boolean
    exibirPickerTime?: boolean
    dataTestid?: string
    id?: string
    entradaManual?: boolean
    desabilitado?: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MCalendario',
  props: {
    rotulo: { default: "" },
    formatoData: { default: "dd.mm.yy" },
    formatoHora: { default: "24" },
    somenteHora: { type: Boolean },
    modelValue: null,
    obrigatorio: { type: Boolean },
    mostrarHoras: { type: Boolean },
    destino: null,
    mensagemDeErro: null,
    icon: null,
    maxData: null,
    minData: null,
    esconderPicker: { type: Boolean },
    exibirPickerTime: { type: Boolean },
    dataTestid: { default: "MCalendario__Calendario" },
    id: null,
    entradaManual: { type: Boolean, default: true },
    desabilitado: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "update:modelValue", modelValue?: CalendarValueType): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { rotulo: string, formatoData: string, formatoHora: CalendarHourFormatType, somenteHora?: boolean, modelValue: CalendarValueType | Ref<CalendarValueType>, obrigatorio?: boolean, mostrarHoras?: boolean, destino?: string, mensagemDeErro?: string | Ref<string>, icon?: string, maxData?: Date, minData?: Date, esconderPicker?: boolean, exibirPickerTime?: boolean, dataTestid: string, id?: string, entradaManual: boolean, desabilitado?: boolean }

  

  

  const emitirModel = computed({
    get(): CalendarValueType {
      return props.modelValue as CalendarValueType
    },
    set(value: CalendarValueType) {
      emitir("update:modelValue", value)
    },
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Calendar), {
      modelValue: _unref(emitirModel),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(emitirModel) ? (emitirModel).value = $event : null)),
      "append-to": __props.destino,
      "aria-describedby": "input-help",
      class: _normalizeClass(["MCalendario__Calendario", { 'p-invalid': __props.mensagemDeErro }]),
      "data-testid": __props.dataTestid,
      "date-format": __props.formatoData,
      disabled: __props.desabilitado,
      "hour-format": __props.formatoHora,
      icon: __props.icon,
      "input-id": __props.id,
      "manual-input": __props.entradaManual,
      "max-date": __props.maxData,
      "min-date": __props.minData,
      "show-icon": true,
      "show-time": __props.mostrarHoras,
      "time-only": __props.somenteHora
    }, null, 8, ["modelValue", "append-to", "class", "data-testid", "date-format", "disabled", "hour-format", "icon", "input-id", "manual-input", "max-date", "min-date", "show-time", "time-only"]),
    _createElementVNode("label", {
      class: "MCalendario__Rotulo",
      for: __props.id
    }, [
      _createTextVNode(_toDisplayString(__props.rotulo), 1),
      (__props.obrigatorio)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2),
    _withDirectives(_createElementVNode("small", {
      id: "input-help",
      class: "p-error",
      "data-testid": "input-error"
    }, _toDisplayString(__props.mensagemDeErro), 513), [
      [_vShow, __props.mensagemDeErro]
    ])
  ]))
}
}

})